import {
  CALLS_FETCH,
  CALLS_FETCH_FAILURE,
  CALLS_FETCH_SUCCESS,
  CALLS_RESET,
  CALLS_SELECTION_SET,
  CALLS_SET,
  CALLS_DEEPLINK_FETCH,
  CALLS_DEEPLINK_FETCH_FAILURE,
  CALLS_DEEPLINK_FETCH_SUCCESS,
} from "../actionTypes";

const INITIAL_STATE = {
  calls: [],
  selectedCalls: [],
  deepLinkCall: {},
  loading: false,
  error: null,
  algoliaTotalPages: 0,
  algoliaTotalItems: 0,
};

export default function CallsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CALLS_FETCH:
      return { ...state, loading: true, error: null };
    case CALLS_DEEPLINK_FETCH:
      return { ...state, loading: true, error: null };
    case CALLS_FETCH_SUCCESS: {
      const {
        payload,
        algoliaTotalPages = state.algoliaTotalPages,
        algoliaTotalItems = state.algoliaTotalItems,
      } = action;
      return {
        ...state,
        calls: payload,
        loading: false,
        error: null,
        algoliaTotalPages,
        algoliaTotalItems,
      };
    }
    case CALLS_DEEPLINK_FETCH_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        deepLinkCall: payload,
        loading: false,
        error: null,
      };
    }
    case CALLS_SELECTION_SET: {
      const { payload } = action;

      return {
        ...state,
        selectedCalls: payload,
      };
    }
    case CALLS_FETCH_FAILURE: {
      const { payload } = action;
      return { ...state, loading: false, error: payload };
    }
    case CALLS_DEEPLINK_FETCH_FAILURE: {
      const { payload } = action;
      return { ...state, loading: false, error: payload };
    }
    case CALLS_SET: {
      const { payload } = action;
      return { ...state, calls: payload };
    }
    case CALLS_RESET: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}
